var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _commonTypes = require("./commonTypes");
var _mutables = require("./mutables");
function initSensorData(sensorType) {
    if (sensorType === _commonTypes.SensorType.ROTATION) {
        return (0, _mutables.makeMutable)({
            qw: 0,
            qx: 0,
            qy: 0,
            qz: 0,
            yaw: 0,
            pitch: 0,
            roll: 0,
            interfaceOrientation: 0
        });
    } else {
        return (0, _mutables.makeMutable)({
            x: 0,
            y: 0,
            z: 0,
            interfaceOrientation: 0
        });
    }
}
var Sensor = exports.default = function() {
    function Sensor(sensorType, config) {
        (0, _classCallCheck2.default)(this, Sensor);
        this.listenersNumber = 0;
        this.sensorId = null;
        this.sensorType = void 0;
        this.data = void 0;
        this.config = void 0;
        this.sensorType = sensorType;
        this.config = config;
        this.data = initSensorData(sensorType);
    }
    (0, _createClass2.default)(Sensor, [
        {
            key: "register",
            value: function register(eventHandler) {
                var config = this.config;
                var sensorType = this.sensorType;
                this.sensorId = _NativeReanimated.default.registerSensor(sensorType, config.interval === "auto" ? -1 : config.interval, config.iosReferenceFrame, eventHandler);
                return this.sensorId !== -1;
            }
        },
        {
            key: "isRunning",
            value: function isRunning() {
                return this.sensorId !== -1 && this.sensorId !== null;
            }
        },
        {
            key: "isAvailable",
            value: function isAvailable() {
                return this.sensorId !== -1;
            }
        },
        {
            key: "getSharedValue",
            value: function getSharedValue() {
                return this.data;
            }
        },
        {
            key: "unregister",
            value: function unregister() {
                if (this.sensorId !== null && this.sensorId !== -1) {
                    _NativeReanimated.default.unregisterSensor(this.sensorId);
                }
                this.sensorId = null;
            }
        }
    ]);
    return Sensor;
}();
